// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: var(--sidebar-width);
  height: 100vh;
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  color: white;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar.collapsed {
  width: 70px;
}

.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.logo {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 70px;
}

.sidebar.collapsed .logo {
  justify-content: center;
  padding: 20px 10px;
}

.logo i {
  font-size: 28px;
  color: var(--primary-color);
}

.logo h2 {
  font-size: 20px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
}

.hamburger-toggle {
  position: absolute;
  top: 20px;
  right: 15px;
  width: 36px;
  height: 36px;
  background: rgba(102, 126, 234, 0.2);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1001;
}

.hamburger-toggle:hover {
  background: rgba(102, 126, 234, 0.3);
  transform: scale(1.05);
}

.hamburger-toggle i {
  font-size: 18px;
  font-weight: bold;
  transition: transform 0.3s ease;
}

.sidebar.collapsed .hamburger-toggle {
  right: 50%;
  transform: translateX(50%);
}

.sidebar.collapsed .hamburger-toggle:hover {
  transform: translateX(50%) scale(1.05);
}

.nav-menu {
  padding: 20px 0;
  flex: 1 1;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 25px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
  white-space: nowrap;
  position: relative;
}

.sidebar.collapsed .nav-item {
  padding: 15px;
  justify-content: center;
  gap: 0;
}

.sidebar.collapsed .nav-item span {
  position: absolute;
  left: 70px;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  padding: 10px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  white-space: nowrap;
  z-index: 1002;
  pointer-events: none;
  border: 1px solid rgba(102, 126, 234, 0.3);
  font-size: 14px;
  font-weight: 500;
}

.sidebar.collapsed .nav-item span::before {
  content: '';
  position: absolute;
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid #1e293b;
}

.sidebar.collapsed .nav-item:hover span {
  opacity: 1;
  visibility: visible;
  left: 80px;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: white;
  border-left-color: var(--primary-color);
}

.nav-item.active {
  background: rgba(79, 70, 229, 0.1);
  color: white;
  border-left-color: var(--primary-color);
}

.nav-item i {
  font-size: 18px;
  width: 20px;
  text-align: center;
}

.sidebar-footer {
  margin-top: auto;
  padding: 12px 0 20px;
}

.logout-button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 25px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
  white-space: nowrap;
}

.logout-button:hover {
  background: rgba(239, 68, 68, 0.15);
  color: #ffffff;
  border-left-color: #ef4444;
}

.logout-button i {
  font-size: 18px;
  width: 20px;
  text-align: center;
}

.sidebar.collapsed .logout-button {
  padding: 15px;
  justify-content: center;
  gap: 0;
}

@media (max-width: 1024px) {
  .sidebar {
    transform: translateX(-100%);
  }
  
  .sidebar.open {
    transform: translateX(0);
  }

  .hamburger-toggle {
    display: none;
  }
}

/* Pulse animation for hamburger on first load */
@keyframes pulse {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.5);
  }
  50% {
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.8), 0 0 0 8px rgba(102, 126, 234, 0.2);
  }
}

.hamburger-toggle {
  animation: pulse 2s ease-in-out 3;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,2BAA2B;EAC3B,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,kBAAkB;EAClB,2DAA2D;EAC3D,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,+CAA+C;EACjD;EACA;IACE,mFAAmF;EACrF;AACF;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: var(--sidebar-width);\n  height: 100vh;\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar.collapsed {\n  width: 70px;\n}\n\n.sidebar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n}\n\n.logo {\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  min-height: 70px;\n}\n\n.sidebar.collapsed .logo {\n  justify-content: center;\n  padding: 20px 10px;\n}\n\n.logo i {\n  font-size: 28px;\n  color: var(--primary-color);\n}\n\n.logo h2 {\n  font-size: 20px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.hamburger-toggle {\n  position: absolute;\n  top: 20px;\n  right: 15px;\n  width: 36px;\n  height: 36px;\n  background: rgba(102, 126, 234, 0.2);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 1001;\n}\n\n.hamburger-toggle:hover {\n  background: rgba(102, 126, 234, 0.3);\n  transform: scale(1.05);\n}\n\n.hamburger-toggle i {\n  font-size: 18px;\n  font-weight: bold;\n  transition: transform 0.3s ease;\n}\n\n.sidebar.collapsed .hamburger-toggle {\n  right: 50%;\n  transform: translateX(50%);\n}\n\n.sidebar.collapsed .hamburger-toggle:hover {\n  transform: translateX(50%) scale(1.05);\n}\n\n.nav-menu {\n  padding: 20px 0;\n  flex: 1;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px 25px;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border-left: 3px solid transparent;\n  white-space: nowrap;\n  position: relative;\n}\n\n.sidebar.collapsed .nav-item {\n  padding: 15px;\n  justify-content: center;\n  gap: 0;\n}\n\n.sidebar.collapsed .nav-item span {\n  position: absolute;\n  left: 70px;\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  padding: 10px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  white-space: nowrap;\n  z-index: 1002;\n  pointer-events: none;\n  border: 1px solid rgba(102, 126, 234, 0.3);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.sidebar.collapsed .nav-item span::before {\n  content: '';\n  position: absolute;\n  left: -6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 6px solid #1e293b;\n}\n\n.sidebar.collapsed .nav-item:hover span {\n  opacity: 1;\n  visibility: visible;\n  left: 80px;\n}\n\n.nav-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: white;\n  border-left-color: var(--primary-color);\n}\n\n.nav-item.active {\n  background: rgba(79, 70, 229, 0.1);\n  color: white;\n  border-left-color: var(--primary-color);\n}\n\n.nav-item i {\n  font-size: 18px;\n  width: 20px;\n  text-align: center;\n}\n\n.sidebar-footer {\n  margin-top: auto;\n  padding: 12px 0 20px;\n}\n\n.logout-button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px 25px;\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-left: 3px solid transparent;\n  white-space: nowrap;\n}\n\n.logout-button:hover {\n  background: rgba(239, 68, 68, 0.15);\n  color: #ffffff;\n  border-left-color: #ef4444;\n}\n\n.logout-button i {\n  font-size: 18px;\n  width: 20px;\n  text-align: center;\n}\n\n.sidebar.collapsed .logout-button {\n  padding: 15px;\n  justify-content: center;\n  gap: 0;\n}\n\n@media (max-width: 1024px) {\n  .sidebar {\n    transform: translateX(-100%);\n  }\n  \n  .sidebar.open {\n    transform: translateX(0);\n  }\n\n  .hamburger-toggle {\n    display: none;\n  }\n}\n\n/* Pulse animation for hamburger on first load */\n@keyframes pulse {\n  0%, 100% {\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.5);\n  }\n  50% {\n    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.8), 0 0 0 8px rgba(102, 126, 234, 0.2);\n  }\n}\n\n.hamburger-toggle {\n  animation: pulse 2s ease-in-out 3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
